<ng-container *ngIf="!!jobPositions">

  <h4>Lieferantenaufträge</h4>
  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'order_id'">Auftrag</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Auftragnehmer</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_subject'">Beschreibung</clr-dg-column>
    <clr-dg-column>Datum</clr-dg-column>
    <clr-dg-column>Bestellter Liefertermin</clr-dg-column>
    <clr-dg-column [clrDgField]="'reqid'">Referenz (Request)</clr-dg-column>
    <clr-dg-column>Summe (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Order for this Project!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let order of orders">
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.project_id }}.0002.{{ order.order_id }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.company_name }}<br />({{ order.order_salutation}} {{ order.order_lastname}})</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]"><b>{{ order.order_subject }}</b></clr-dg-cell>
      <clr-dg-cell>{{ order.order_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_delivery | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/request/details', order.project_id, order.reqid]">{{ order.project_id }}.0001.{{ order.reqid }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ order.purchasing_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
      <clr-dg-cell [className]="findButtonClass(order.order_status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <span class="alert-text">{{ getCellStatus(order.order_status).statusDisplay}}</span>
          </div>
        </div>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Anfragen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{orders.length}} Anfrage(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>

  <h4>Positionsübersicht</h4>
  <tr *ngIf="jobPositions.length > 0">
    <td>
      <table class="table table-compact tabletop small">
        <thead>
        <tr>
          <th class="left">Position</th>
          <th class="left">Auftragsnummer</th>
          <th class="left">Auftragnehmer</th>
          <th class="left">Beschreibung</th>
          <th class="right">Anzahl</th>
          <th class="left">Name</th>
          <th class="left">Zeichnungsnummer</th>
          <th class="left">Seriennummer</th>
          <th class="left">Bestätigter Liefertermin</th>
          <th class="left">Status</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let position of jobPositions">
          <td class="left"><span *ngIf="position.part > 0"><cds-icon shape="child-arrow"></cds-icon></span>{{ position.position }}<span *ngIf="position.part > 0">.{{ position.part }}</span></td>
          <td class="left" [routerLink]="['/order/details', projectID, position.orderid]">{{ projectID + '.0002.' + position.orderid }}</td>
          <td class="left" [routerLink]="['/contacts/details', position.ordercid]">{{ position.company_name }}</td>
          <td class="left">{{ position.order_subject }}</td>
          <td class="center"><span *ngIf="!position.technology">{{ position.number_of_pieces }}</span></td>
          <td class="left" [routerLink]="['/component/details', position.technical_drawing]">{{ position.name }}</td>
          <td class="left" [routerLink]="['/component/details', position.technical_drawing]">
            <span *ngIf="position.technology"><cds-icon shape="cog" class="is-solid"></cds-icon></span>
            {{ position.technical_drawing }}
          </td>
          <td class="left"><span *ngIf="((position.serial_nr) && (position.serial_nr !== 'null'))">{{ position.serial_nr }}</span></td>
          <td class="left"><span *ngIf="((position.delivery_date) && (position.delivery_date !== '2020-01-01'))">{{ position.delivery_date | date: 'dd.MM.yyyy' }}</span></td>
          <td class="left">{{ getCellStatus(position.status).statusDisplay}}</td>
        </tr>
        </tbody>
      </table>
    </td>
  </tr>
</ng-container>
